import { useMutation, UseMutationResult } from "react-query"
import { localConfig } from "../../../Configs/localConfig"
import { errorAlert, loadingAlert, successAlert } from "../../../utils/alert"
import { api } from "../../api"

interface ParamsDeleteAdjuvantes {
  cod_adjuvante: number
  refetch_deletar: Function
}

export const useDeleteAdjuvantes = (): {
  carregando_deletar_adjuvantes: boolean
  mudateDeletarAdjuvantes: (params: ParamsDeleteAdjuvantes) => void
} => {
  const mutation: UseMutationResult<Response, Error, ParamsDeleteAdjuvantes> = useMutation(
    async (params: ParamsDeleteAdjuvantes) => {
      const { cod_adjuvante, refetch_deletar } = params

      const { conta, codCliente } = localConfig()
      const isCliente = localStorage.getItem('cod-cliente') !== '' && localStorage.getItem('cod-cliente') !== undefined

      loadingAlert({ msg: 'Excluindo...', id: 'delete_fertilizante' })
      const paramCliente = isCliente && codCliente ? `&codCliente=${codCliente}` : ''
      return api
        .delete(`/recomendacao/adjuvante/${cod_adjuvante}?codConta=${conta}${paramCliente}`)
        .then((response: any) => {
          successAlert('Excluído com sucesso!', 5000, 'delete_fertilizante')
          refetch_deletar?.()
          return response
        })
        .catch((error: Error) => {
          //@ts-ignore
          let error_response = error?.response?.data
          errorAlert(
            error_response?.error ?? 'Falha ao excluir fertilizante',
            5000,
            'delete_fertilizante'
          )

          throw error
        })
    }
  )

  return {
    carregando_deletar_adjuvantes: mutation.isLoading,
    mudateDeletarAdjuvantes: mutation.mutate,
  }
}